import { lazy } from "react";

const PagesRoutes = [
  {
    path: "/login",
    component: lazy(() => import("../../view/authentication/login")),
    layout: "FullLayout",
  },
  {
    path: "/forgot-password",
    component: lazy(() => import("../../view/authentication/forgotPassword")),
    layout: "FullLayout",
  },
  {
    path: "/reset-password",
    component: lazy(() => import("../../view/authentication/resetPassword")),
    layout: "FullLayout",
  },
  {
    path: "/quick-create",
    component: lazy(() => import("../../view/quick-create")),
    layout: "FullLayout",
  },
  {
    path: "/dashboard",
    component: lazy(() => import("../../view/dashboard")),
    layout: "VerticalLayout",
  },
  {
    path: "/place-order",
    component: lazy(() => import("../../view/place-order")),
    layout: "VerticalLayout",
  },
  {
    path: "/equipment-details",
    component: lazy(() => import("../../view/equipment-details")),
    layout: "VerticalLayout",
  },
  {
    path: "/orders",
    component: lazy(() => import("../../view/orders")),
    layout: "VerticalLayout",
  },
  {
    path: "/create-supply-order",
    component: lazy(() => import("../../view/create-supply-order")),
    layout: "VerticalLayout",
  },
  {
    path: "/deliveries",
    component: lazy(() => import("../../view/deliveries")),
    layout: "VerticalLayout",
  },
  {
    path: "/invoices",
    component: lazy(() => import("../../view/invoices")),
    layout: "VerticalLayout",
  },
  {
    path: "/payments",
    component: lazy(() => import("../../view/payment")),
    layout: "VerticalLayout",
  },
  {
    path: "/payment-reports",
    component: lazy(() => import("../../view/payment/payment-reports")),
    layout: "VerticalLayout",
  },
  {
    path: "/service-calls",
    component: lazy(() => import("../../view/service-calls")),
    layout: "VerticalLayout",
  },
  {
    path: "/return-request",
    component: lazy(() => import("../../view/return-request")),
    layout: "VerticalLayout",
  },
  {
    path: "/create-return",
    component: lazy(() => import("../../view/return-request/create-return-request")),
    layout: "VerticalLayout",
  },
  {
    path: "/contracts",
    component: lazy(() => import("../../view/contracts")),
    layout: "VerticalLayout",
  },
  {
    path: "/label-print",
    component: lazy(() => import("../../view/label-print")),
    layout: "VerticalLayout",
  },
  // Support Desk
  {
    path: "/support-desk/dashboard",
    component: lazy(() => import("../../view/support-desk/dashboard")),
    layout: "VerticalLayout",
  },
  {
    path: "/support-desk/tickets",
    component: lazy(() => import("../../view/support-desk/tickets")),
    layout: "VerticalLayout",
  },
  {
    path: "/setting/user-profile",
    component: lazy(() => import("../../view/settings")),
    layout: "VerticalLayout",
  },
  {
    path: "/setting/authorization",
    component: lazy(() => import("../../view/settings")),
    layout: "VerticalLayout",
  },
  {
    path: "/setting/email-credential",
    component: lazy(() => import("../../view/settings")),
    layout: "VerticalLayout",
  },
  {
    path: "/setting/quick-create",
    component: lazy(() => import("../../view/settings")),
    layout: "VerticalLayout",
  },
  {
    path: "/setting/support-desk",
    component: lazy(() => import("../../view/settings")),
    layout: "VerticalLayout",
  },
  {
    path: "/pages/error-404",
    component: lazy(() => import("../../view/pages/errors/404")),
    layout: "FullLayout",
  },
];

export default PagesRoutes;